import { satoshisToDollars, dollarsToSatoshis } from "../../utils";
import { productStatusToServiceStatus, serviceStatusToProductStatus } from "../product";
import { serviceInventoryMediaTypeToInventoryMediaType, inventoryMediaTypeToServiceInventoryMediaType, serviceInventoryVideoTypeToInventoryVideoType, inventoryVideoTypeToServiceInventoryVideoType } from "../inventories";
/**
 * Converts service product row to UI format.
 * Transforms status, media type, video type, and CPMs (satoshis to dollars).
 *
 * The pricing screen only displays existing products, which always have a media type.
 * VT_NONE video_type is converted to undefined for audio products.
 *
 * @param row - Service product pricing row
 * @returns UI-formatted product pricing row
 */
export const productPricingRowFromService = (row) => {
    return {
        id: row.id,
        name: row.name,
        status: serviceStatusToProductStatus(row.status),
        mediaType: serviceInventoryMediaTypeToInventoryMediaType(row.media_type),
        videoType: serviceInventoryVideoTypeToInventoryVideoType(row.product_type),
        ...(row.default_retail_cpm != null && {
            defaultRetailCpm: satoshisToDollars(row.default_retail_cpm)
        }),
        cpm: row.cpm != null ? satoshisToDollars(row.cpm) : undefined
    };
};
/**
 * Converts UI product row to service format.
 * Transforms status, media type, video type, and CPMs (dollars to satoshis).
 *
 * The pricing screen only displays existing products, which always have media and video types set.
 *
 * @param row - UI product pricing row
 * @returns Service-formatted product pricing row
 */
export const productPricingRowToService = (row) => {
    return {
        id: row.id,
        name: row.name,
        status: productStatusToServiceStatus(row.status),
        media_type: inventoryMediaTypeToServiceInventoryMediaType(row.mediaType),
        product_type: inventoryVideoTypeToServiceInventoryVideoType(row.videoType),
        ...(row.defaultRetailCpm != null && {
            default_retail_cpm: dollarsToSatoshis(row.defaultRetailCpm)
        }),
        cpm: row.cpm != null ? dollarsToSatoshis(row.cpm) : undefined
    };
};
/**
 * Converts service station group row to UI format.
 * Transforms field naming and CPM (satoshis to dollars).
 * @param row - Service station group pricing row
 * @returns UI-formatted station group pricing row
 */
export const stationGroupPricingRowFromService = (row) => {
    return {
        stationGroupId: row.id,
        stationGroupName: row.name,
        metro: row.metro,
        cpm: row.cpm != null ? satoshisToDollars(row.cpm) : undefined
    };
};
/**
 * Converts UI station group row to service format.
 * Transforms field naming and CPM (dollars to satoshis).
 * @param row - UI station group pricing row
 * @returns Service-formatted station group pricing row
 */
export const stationGroupPricingRowToService = (row) => {
    return {
        id: row.stationGroupId,
        name: row.stationGroupName,
        metro: row.metro,
        cpm: row.cpm != null ? dollarsToSatoshis(row.cpm) : undefined
    };
};
/**
 * Converts service upsert item to UI format.
 * Transforms CPM from satoshis to dollars.
 * @param upsert - Service station group CPM upsert item
 * @returns UI-formatted upsert item
 */
export const stationGroupCpmUpsertFromService = (upsert) => {
    return {
        productId: upsert.prod_id,
        stationGroupId: upsert.station_group_id,
        cpm: upsert.cpm != null ? satoshisToDollars(upsert.cpm) : undefined
    };
};
/**
 * Converts service response to UI format.
 * @param response - Service upsert response
 * @returns UI-formatted upsert response
 */
export const upsertStationGroupCpmResponseFromService = (response) => {
    return {
        upserts: response.upserts.map(stationGroupCpmUpsertFromService)
    };
};
//# sourceMappingURL=shared.js.map